import React from 'react';

import '../../styles/scss/style.scss';
import image from "../images/aloopproxfront.png";


export const Hero01 = () => {
  return (
	  <div className="hero animated fadeInUp" style={{marginTop:"5rem"}}>
			<div className="feature__wrap">
				<div className="text-center w-100">
					<h2>Best Productivity hack for Designers and Startups</h2>
					<p><strong>Loop Pro X</strong> helps you create outstanding websites, webapps and widgets in record time. <br/> Thereby enabling you focus on other important aspects of your project</p>
				   <br/>	
				  <a href="https://www.figma.com/proto/VgccgKbbxDwXrqMSTJS842/Loop-Pro-X?node-id=201%3A32&viewport=297%2C200%2C0.02586517482995987&scaling=scale-down" target="_blank" rel="noreferrer" className="btn btn1-lg btn-primary mr-0">Preview Loop Pro X</a>
					<p className="mt-2 mb-5"><small>Compatible with figma</small></p>
					<img className="shadow w-100" alt="heroimg" src={image}/>
			  </div>
			  
			</div>
		</div>
  );
};
